export const BOOLEAN_FIELD_NAME_SUFFIX = '-switcher';

const fieldNames = {
  LINK_TYPE: 'link-type',
  ANCHOR_REFERENCE: 'anchor-reference',
  ANCHOR_PAGE_ID: 'anchor-page-id',
  PHONE_REFERENCE: 'phone-reference',
  MAIL_REFERENCE: 'mail-reference',
  PAGE_REFERENCE: 'page-reference',
  EXTERNAL_URL: 'external-url',
  EXTERNAL_TARGET_BLANK_SWITCHER: `external-target-blank${BOOLEAN_FIELD_NAME_SUFFIX}`,
  EXTERNAL_NOFOLLOW_SWITCHER: `external-nofollow${BOOLEAN_FIELD_NAME_SUFFIX}`,
  DOWNLOAD_FILE_NAME: 'download-file-name',
  DOWNLOAD_FILE: 'download-file',
  DOWNLOAD_OPTION: 'download-option',
  DOWNLOAD_CUSTOM_PATH: 'download-custom-path',
  DOWNLOAD_CUSTOM_PATH_SWITCHER: `download-custom-path${BOOLEAN_FIELD_NAME_SUFFIX}`,
  DOWNLOAD_REFERENCE: 'download-reference',
};

export default fieldNames;
